import React from 'react';

interface DashboardErrorBoundaryProps {
  title?: string;
  children: React.ReactNode;
}

interface DashboardErrorBoundaryState {
  error: Error | null;
}

/** Catches render crashes so one bad progress/report row cannot white-screen the page. */
export class DashboardErrorBoundary extends React.Component<
  DashboardErrorBoundaryProps,
  DashboardErrorBoundaryState
> {
  state: DashboardErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): DashboardErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('DashboardErrorBoundary caught render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            margin: '1.5rem',
            padding: '1.25rem 1.5rem',
            borderRadius: 12,
            background: '#fff5f5',
            border: '1px solid #fecaca',
            color: '#7f1d1d',
          }}
        >
          <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>
            {this.props.title || 'This panel crashed'}
          </h2>
          <p style={{ margin: '0 0 0.75rem 0' }}>
            {this.state.error.message || 'Unknown render error'}
          </p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: 8,
              border: '1px solid #f87171',
              background: '#fff',
              color: '#b91c1c',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
